export const getVideoRepository = ({
  videoODataService,
}) => {
  const addVideoCreative = ({ videoCreative, sourceType }) => {
    const res = videoODataService.addVideoCreative({ videoCreative, sourceType }).then(result => result.value);
    return res;
  };

  const getVideo = ({ id, fetchMetadata }) => videoODataService.getVideo({ id, fetchMetadata });

  return {
    addVideoCreative,
    getVideo,
  };
};
